<template>
  <section
    id="lost-found"
    class="lost-found-section"
  >
    <div class="section-container">
      <div class="section-header">
        <span class="section-badge outline">Lost and Found</span>
        <h2 class="section-title">
          Recently Found Items
        </h2>
        <p class="section-subtitle">
          Check recently recovered items. Sign in to claim your item or file a new lost item report.
        </p>
      </div>

      <div class="marquee-wrap">
        <div class="marquee-track">
          <span
            v-for="(item, index) in marqueeItems"
            :key="`a-${index}`"
            class="marquee-item"
          >
            {{ item }}
          </span>
          <span
            v-for="(item, index) in marqueeItems"
            :key="`b-${index}`"
            class="marquee-item"
          >
            {{ item }}
          </span>
        </div>
      </div>

      <div class="action-wrap">
        <router-link
          to="/sign-in"
          class="btn btn-success px-4 py-2"
        >
          <i class="fas fa-sign-in-alt me-2" />
          Lost something? Report here
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/css/landing/sections/common.css'
import { SSharedLanding } from '@/services'

export default {
  name: 'LostFoundSection',

  data () {
    return {
      marqueeItems: []
    }
  },

  mounted () {
    this.fetchFoundItems()
  },

  methods: {
    async fetchFoundItems () {
      try {
        const { data } = await SSharedLanding.searchFoundItems({ per_page: 12, page: 1 })
        const items = data?.data?.items || data?.data || []

        this.marqueeItems = items
          .map(item => {
            const description = item?.description || item?.title || 'Found item'
            const location = item?.location || item?.location_lost_found || 'Campus'
            return `${description} - ${location}`
          })
          .filter(Boolean)
      } catch (error) {
        this.marqueeItems = []
      }

      if (!this.marqueeItems.length) {
        this.marqueeItems = ['No recently found items available right now']
      }
    }
  }
}
</script>

<style scoped>
.lost-found-section {
  padding: 3rem 1.5rem;
  background: #f8fafc;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
}

.marquee-wrap {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  width: 100%;
}

.marquee-track {
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: max-content;
  min-width: 100%;
  animation: marquee 22s linear infinite;
}

.marquee-item {
  display: inline-flex;
  align-items: center;
  padding: 0.9rem 1.25rem;
  max-width: min(72vw, 460px);
  overflow: hidden;
  text-overflow: ellipsis;
  color: #334155;
  font-size: 0.9rem;
  font-weight: 600;
}

.marquee-item::after {
  content: '\2022';
  color: #10b981;
  margin-left: 1.25rem;
}

.action-wrap {
  display: flex;
  justify-content: center;
  margin-top: 1.25rem;
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 768px) {
  .marquee-item {
    max-width: min(84vw, 340px);
    padding: 0.8rem 1rem;
    font-size: 0.85rem;
  }
}
</style>
